import { FC, memo, useCallback, useRef, useState } from 'react'
import { IonBadge, IonRouterLink } from '@ionic/react'

import { appConfig } from '@/services/config'

const ContestWidgetComponent: FC<{
  url: string
  imageUrl: string
  contestName: string
  contestCategory: string
}> = ({ url, imageUrl, contestName, contestCategory }) => {
  const imageRef = useRef<HTMLImageElement>(null)
  const [imageWidth, setImageWidth] = useState(16)
  const getCdnUrl = (url) => `${appConfig.cdn}${url}`
  const measureImageWidth = useCallback(() => {
    if (imageRef !== null) {
      setImageWidth(imageRef.current.clientWidth)
    }
  }, [])

  return (
    <>
      <IonRouterLink className="mb-4 min-w-[6.875rem]" routerLink={`${url}`}>
        <div className="h-[13.25rem] w-40">
          <img
            alt={contestName}
            ref={imageRef}
            className="object-cover rounded-[0.625rem] h-full"
            onLoad={measureImageWidth}
            src={getCdnUrl(imageUrl)}
          />
        </div>
        <strong className="flex flex-col items-start mt-2">
          <span
            style={{ maxWidth: `${imageWidth}px` }}
            className="text-xs block whitespace-nowrap text-white text-ellipsis overflow-hidden w-full text-left"
          >
            #{contestName}
          </span>
          <IonBadge className="plain lowercase rounded-full pl-0 px-1 mt-2">
            <span className="text-xxs opacity-60 leading-4 px-1">{`#${contestCategory}`}</span>
          </IonBadge>
        </strong>
      </IonRouterLink>
    </>
  )
}

export const ContestWidget = memo(ContestWidgetComponent)
